import styled from 'styled-components';

export const DatePickerContainer = styled.div`
  background-color: white;
`;
